export default "/images/vendor/flag-icons/flags/1x1/bz.svg?2466e1694643ccb84c88b66d184e5060";